import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from 'src/app/Services/services/auth.service';
import { UserAuthManager } from 'src/app/Services/user-sessions/user-auth-manager';
import {
  HttpErrorUtil,
  HttpUnauthorizedException,
} from 'src/app/utils/http-util/http-error.util';
import { environment } from 'src/environments/environment';
import {
  ICreateFlashcard,
  IFlashcard,
  IFlashcardUsage,
  IGetFlashcardPayload,
  IUpdateFlashcard,
} from '../interface/falshcard.interface';
import { AppOfflineStore } from 'src/app/app.offlineService';

@Injectable({
  providedIn: 'root',
})
export class AddEditFlashManagementService {
  private BASE_URL = environment.apiBaseUrl;

  constructor(
    private readonly toaster: ToastrService,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly httpClient: HttpClient,
    private appserv: AppOfflineStore
  ) {}

  getDropdownList<T>(code: string): Observable<any[]> {
    return this.httpClient
      .get<{ resultList: any[] }>(`${this.BASE_URL}api/GetCodes/${code}`)
      .pipe(
        map((response) => response.resultList),
        catchError((err: HttpErrorResponse) => this.handlerError(err))
      );
  }

  getFlashcard(getFlashcard: IGetFlashcardPayload) {
    getFlashcard.SessionLanguageTypeCode = this.appserv.userlanuage;
    return this.httpClient
      .post<{ result: Array<IFlashcard> }>(
        `${this.BASE_URL}/api/GetFlashCard`,
        getFlashcard
      )
      .pipe(
        catchError((err: HttpErrorResponse) => this.handlerError(err)),
        map(
          (accu: { result: Array<IFlashcard> }) => accu.result[0] as IFlashcard
        )
      );
  }

  getFlashcards(getFlashcard: IGetFlashcardPayload) {
    getFlashcard.SessionLanguageTypeCode = this.appserv.userlanuage;
    return this.httpClient
      .post<Array<IFlashcard>>(
        `${this.BASE_URL}/api/GetFlashCard`,
        getFlashcard
      )
      .pipe(
        catchError((err: HttpErrorResponse) => this.handlerError(err))
        // map((accu: Array<IFlashcard>) => accu as unknown as Array<IFlashcard>)
      );
  }
  getFlashcardsActivityHistory(getFlashcard: IGetFlashcardPayload) {
    return this.httpClient
      .post<Array<IFlashcard>>(
        `${this.BASE_URL}/api/GetFlashCardActivityHistory`,
        getFlashcard
      )
      .pipe(
        catchError((err: HttpErrorResponse) => this.handlerError(err)),
        map((accu: Array<IFlashcard>) => accu as unknown as Array<IFlashcard>)
      );
  }

  getFlashcardUsage(loggedInUserId: string, flashcardId: string) {
    return this.httpClient
      .get<Array<IFlashcardUsage>>(
        `${this.BASE_URL}/api/GetFlashCardUsage?loggedInUser=${loggedInUserId}&flashcardId=${flashcardId}`
      )
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  createFlashcard(createFlashCardPayload: ICreateFlashcard) {
    return this.httpClient
      .post(
        `${this.BASE_URL}/api/InsertOrUpdateFlashCard`,
        createFlashCardPayload
      )
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  updateFlashcard(updateFlashCardPayload: IUpdateFlashcard) {
    return this.httpClient
      .put(
        `${this.BASE_URL}/api/InsertOrUpdateFlashCard`,
        updateFlashCardPayload
      )
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  deleteImageFromTextEditor(url: string) {
    return this.httpClient
      .post(`${this.BASE_URL}/api/deleteImageForRTE`, {
        path: url,
      })
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  private handlerError(err: HttpErrorResponse) {
    const error = HttpErrorUtil.sanitizeError(err);

    if (error instanceof HttpUnauthorizedException) {
      UserAuthManager.userSessionLogout.next();
      this.authService.logout();
      this.router.navigate(['/login']);
      this.toaster.warning(error.message, 'Logout Successfully');
    } else {
      this.toaster.error(error.message, 'Error');
    }

    return throwError(error);
  }
}
